import { AuthModel, AuthRequestModel } from "@tsin-core/models/auth.model";

const ACTION_SCOPE = '[Auth]';

export class AuthenticateAction {
  static readonly type = `${ACTION_SCOPE} Login`;
  constructor(public payload: AuthRequestModel) { }
}

export class LogoutAction {
  static readonly type = `${ACTION_SCOPE} Logout`;
}

export class ValidateTokenAction {
  static readonly type = `${ACTION_SCOPE} Validate Token`;
  constructor(public payload: { token: string; refreshToken: string }) { }
}

export class RefreshTokenAction {
  static readonly type = `${ACTION_SCOPE} Refresh Token`;
  constructor(public payload: { refreshToken: string }) { }
}

export class ValidateTokenActionWWU {
  static readonly type = `${ACTION_SCOPE} Validate Token WWU`;
  constructor(public payload: { token: string; refreshToken: string }) { }
}

/**
 * Exchange a Cognito ID token (set as id_token cookie by auth-ui) for an
 * Exams-service JWT, then hydrate the full user profile from the Exams backend.
 *
 * Échange un token Cognito ID (cookie id_token posé par auth-ui) contre un JWT
 * du service Examens, puis charge le profil complet depuis le backend Examens.
 */
export class ExchangeCognitoTokenAction {
  static readonly type = `${ACTION_SCOPE} Exchange Cognito Token`;
  constructor(public payload: { cognitoIdToken: string }) { }
}

export class SetLoading {
  static readonly type = `${ACTION_SCOPE} Set Loading`;
  constructor(public loading: boolean) { }
}

export class SetError {
  static readonly type = `${ACTION_SCOPE} Set Error`;
  constructor(public error: string | null) { }
}
